import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import { LayoutProvider, useLayout } from '../contexts/LayoutContext';
import { Capacitor } from '@capacitor/core';

const isNative = Capacitor.isNativePlatform();

function Layout() {
  const { hideBottomNav } = useLayout();

  return (
    <div className="min-h-screen bg-background">
      {/* Safe area top spacer — only on native (iOS notch/Dynamic Island) */}
      {isNative && <div className="h-[env(safe-area-inset-top)] bg-background" />}

      <div className={`max-w-[1400px] mx-auto flex flex-col md:flex-row ${isNative ? 'min-h-[calc(100vh-env(safe-area-inset-top))]' : 'min-h-screen'}`}>
        {/* Sidebar — hidden on mobile when bottom nav should be hidden */}
        <div className={hideBottomNav ? 'hidden md:block' : ''}>
          <Sidebar />
        </div>

        {/* Main content */}
        <div
          className={`flex-1 flex flex-col min-w-0 md:pb-0 ${
            hideBottomNav
              ? 'pb-0'
              : isNative
                ? 'pb-[calc(4rem+env(safe-area-inset-bottom))]'
                : 'pb-16'
          }`}
        >
          <div className="flex-1 overflow-hidden">
            <div className="p-3 md:p-4 lg:p-5">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function DashboardLayout() {
  return (
    <LayoutProvider>
      <Layout />
    </LayoutProvider>
  );
}
